import React, { useState } from 'react';
import classNames from 'classnames';

import styles from './assets/seance-actions.module.scss';
import { numberWithCommas } from '../../../../../helpers/format';
interface Props {
    original: any;
    data: any;
    setData: any;
    name: string;
}

const SeanceActionsColumn: React.FunctionComponent<Props> = ({ original, data, setData, name }) => {
    const idValue = data[`${original?.id}`];

    const [valueState, setValue] = useState<string>(idValue?.[`${name}`]);
    const handleSave = () => {
        setData({
            ...data,
            [`${original?.id}`]: {
                ...idValue,
                [name]: `${valueState}`,
            },
        });
    };

    const actionValue = data[`${original?.id}`]?.action;

    const title: any = original?.[`${name}`];

    return (
        <div className={classNames(styles.actions)}>
            {actionValue ? (
                <div>
                    <input
                        className={'mb-2'}
                        type="number"
                        onChange={(event) => setValue(`${event.target.value}`)}
                        value={`${valueState}`}
                    />
                    <button className={'mr-3'} type={'button'} onClick={() => handleSave()}>
                        Save
                    </button>
                    <button type={'button'} onClick={() => setValue(idValue?.[`${name}`])}>
                        Cancel
                    </button>
                </div>
            ) : title ? (
                `$${numberWithCommas(title)}`
            ) : (
                '$0.00'
            )}
        </div>
    );
};

export default SeanceActionsColumn;
